import { getRefreshToken } from "lib/axios/getRefreshToken";
import { getCookies, setCookies } from "lib/cookies";

import { AUTH_COOKIES_KEY } from "constants/index";

export const refreshToken = async () => {
  const refreshTokenFromCookie = getCookies(AUTH_COOKIES_KEY.REFRESH_TOKEN);
  const existingTokenFromCookie = getCookies(AUTH_COOKIES_KEY.TOKEN);

  if (!refreshTokenFromCookie) {
    throw new Error("No existing refresh token found.");
  }

  if (!existingTokenFromCookie) {
    throw new Error("No existing token found.");
  }

  const res = await getRefreshToken(
    refreshTokenFromCookie,
    existingTokenFromCookie
  );
  const { refreshToken, accessToken } = res;
  if (accessToken && refreshToken) {
    setCookies(AUTH_COOKIES_KEY.TOKEN, accessToken);
    setCookies(AUTH_COOKIES_KEY.REFRESH_TOKEN, refreshToken);
    return accessToken;
  } else {
    throw new Error("Failed to refresh token.");
  }
};
